export enum ThreatStatus {
    Open = 'open',
    Resolved = 'resolved',
    Dismissed = 'dismissed',
}
